export default __webpack_public_path__ + "static/media/javascript.38323140.png";